import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const CLASSE_URL = `${backendUrl}/api/salledeclasse/`;

class SalledeclasseService {
	async getAllSalledeclasse() {
		try {
			const response = await axios.get(CLASSE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getSalledeclasse(id) {
		return axios.get(`${CLASSE_URL}${id}/`);
	}

	createSalledeclasse(data) {
		return axios.post(CLASSE_URL, data);
	}

	updateSalledeclasse(id, data) {
		return axios.put(`${CLASSE_URL}${id}/`, data);
	}

	deleteSalledeclasse(id) {
		return axios.delete(`${CLASSE_URL}${id}/`);
	}

	getClassNames(classIds) {
		return axios.get(`${CLASSE_URL}?classIds=${classIds}`);
	}

	const;
	formatIntituleClasse = (value) => {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	};

	getClassOptions() {
		return this.getAllSalledeclasse().then((classes) => {
			// options.unshift({value: null, label: 'Selectionner la salle de classe'});
			return classes.map((classe) => ({
				value: classe.id,
				label: this.formatIntituleClasse(classe.intitule_classe).toUpperCase()
			}));
		});
	}

	getClassOptionsForSpecificClasses() {
		return this.getAllSalledeclasse().then((classes) => {
			const specificClasses = classes.filter(
				(classe) =>
					classe.intitule_classe === 'class_six' ||
					classe.intitule_classe === 'cm2' ||
					classe.intitule_classe === 'class_five' ||
					classe.intitule_classe === 'class_four' ||
					classe.intitule_classe === 'cm1' ||
					classe.intitule_classe === 'ce2'
			);

			return specificClasses.map((classe) => ({
				value: classe.id,
				label: this.formatIntituleClasse(classe.intitule_classe).toUpperCase()
			}));
		});
	}
}

export default new SalledeclasseService();
